import { render, staticRenderFns } from "./Auto.vue?vue&type=template&id=56047188&scoped=true"
import script from "./Auto.vue?vue&type=script&lang=js"
export * from "./Auto.vue?vue&type=script&lang=js"
import style0 from "./Auto.vue?vue&type=style&index=0&id=56047188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56047188",
  null
  
)

export default component.exports